import type { FilterItem } from '@schibsted-nmp/search-frontend-clients/quest';
import React from 'react';
import { deleteParamValue, useSubmitSearch } from '../../data/SearchQuery';

export function useFilterSearch() {
    const { submitSearch } = useSubmitSearch();

    const submitFilterSearch = React.useCallback(
        (filterItem: FilterItem, parentItem?: FilterItem) => {
            submitSearch((urlParams) => {
                const isPreviouslyUnselected = !filterItem.selected;
                if (isPreviouslyUnselected) {
                    selectFilterItem(urlParams, filterItem);
                    deleteParentItem(urlParams, parentItem);
                } else {
                    deleteFilterItem(urlParams, filterItem);
                    deleteSelectedChildItems(urlParams, filterItem);
                    selectSolitaryParentItem(urlParams, filterItem, parentItem);
                }
            });
        },
        [submitSearch],
    );

    return {
        submitFilterSearch,
    };
}

function selectFilterItem(urlParams: URLSearchParams, filterItem: FilterItem) {
    urlParams.append(filterItem.name, filterItem.value);
}

function deleteParentItem(urlParams: URLSearchParams, parentItem?: FilterItem) {
    if (parentItem) {
        deleteParamValue(urlParams, parentItem.name, parentItem.value);
    }
}

function deleteFilterItem(urlParams: URLSearchParams, filterItem: FilterItem) {
    const { name, value } = filterItem;
    deleteParamValue(urlParams, name, value);
}

function deleteSelectedChildItems(
    urlParams: URLSearchParams,
    filterItem: FilterItem,
) {
    const selectedItems = findSelectedChildItems(filterItem);
    selectedItems.forEach((item) => deleteFilterItem(urlParams, item));
}

function findSelectedChildItems(filterItem: FilterItem) {
    const childItems = [...(filterItem.filter_items ?? [])];
    const selectedItems: FilterItem[] = [];

    while (childItems.length) {
        const item = childItems.pop();
        if (item) {
            if (item.selected) {
                selectedItems.push(item);
            }
            childItems.push(...(item.filter_items ?? []));
        }
    }

    return selectedItems;
}

function selectSolitaryParentItem(
    urlParams: URLSearchParams,
    filterItem: FilterItem,
    parentItem?: FilterItem,
) {
    if (parentItem) {
        const hasSolitaryParent = Boolean(
            parentItem.filter_items
                ?.filter((item) => item.selected)
                .every((item) => item.value === filterItem.value),
        );
        if (hasSolitaryParent) {
            urlParams.append(parentItem.name, parentItem.value);
        }
    }
}
